import { SignerContactType } from '@dealstack/shared/lib/generated';
import { isValidEmail } from '@dealstack/shared/lib/validation';

const PHONE_REGEX = /^\+?\d{6,}$/;

export function isValidContact(value: string, channel: SignerContactType): boolean {
	if (channel === SignerContactType.SMS) {
		return PHONE_REGEX.test(value);
	}
	return isValidEmail(value);
}

export function resolveInitialChannel(
	defaultPhone: string,
	defaultEmail: string
): SignerContactType {
	if (defaultEmail && !defaultPhone) {
		return SignerContactType.EMAIL;
	}
	return SignerContactType.SMS;
}
